import $ from "jquery";

$(function () {
    phoneValidateChangeEvent();
    sendConfirmSms();
})

function phoneValidateChangeEvent() {
    $('.js-phone-validate-inp').on('change paste input', function () {
        let phone = $(this).val();
        const phonePrepared = phone.replace(/ /gi, '').replace(/_/gi, '')
        const btnSendRef = $('.js-confirm-code');

        if (phonePrepared.length !== 12) {
            btnSendRef.attr('disabled', true);
            $(this).parent().removeClass('is-invalid');
            return;
        }

        btnSendRef.attr('disabled', false);
    });
}

function sendConfirmSms() {
    $('form#jsPhoneConfirm').on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const actionLink = e.target.action;
        const phoneInput = e.target.getElementsByClassName('js-phone-validate-inp')[0];
        const phone = phoneInput.value;
        const token = document.head.querySelector('meta[name="csrf-token"]');

        axios.post(actionLink, {
            'phone': phone, '_token': token
        })
            .then(function (response) {
                $('.modal-js-phone-ver-container').hide().html(response.data.form).fadeIn();
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 422) {
                        $(phoneInput).siblings('.invalid-feedback').html(error.response.data.message);
                        $(phoneInput).parent().addClass('is-invalid');
                        $('.js-confirm-code').attr('disabled', true);
                    }
                }
            });
    });

    $(document).on('focus', '.input-code-send', function (e) {
        $(this).val('');
    });

    $(document).on('keyup', '.input-code-send', function (e) {
        const btnSendRef = $('.js-confirm-code');
        if (e.key === "Backspace") {
            let $prev = $(this).val('').prev('.input-code-send');
            if ($prev.length) $(this).prev('.input-code-send').focus(); else $(this).blur();
        } else if (e.key === "Delete") {
            let next = $(this).val('').next('.input-code-send');
            if (next.length) $(this).next('.input-code-send').focus(); else $(this).blur();
        } else if (this.value.length === this.maxLength) {
            let next = $(this).next('.input-code-send');
            if (next.length) $(this).next('.input-code-send').val('').focus(); else $(this).blur();
        }

        const code = getCodeMerge();
        btnSendRef.attr('disabled', !(code.length === 4));
    });

    function getCodeMerge() {
        let codeInputs = [];
        [...document.getElementsByClassName('input-code-send')].forEach(function (element, index, array) {
            codeInputs[element.name] = element.value;
        });

        return codeInputs['phone_code_1'] + codeInputs['phone_code_2'] + codeInputs['phone_code_3'] + codeInputs['phone_code_4'];
    }

    $(document).on('submit', 'form#jsCodeBySMSConfirm', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let codeInputs = [];
        const actionLink = e.target.action;
        const inputGroupRef = e.target.getElementsByClassName('sms-code-check-group')[0];
        [...e.target.getElementsByClassName('input-code-send')].forEach(function (element, index, array) {
            codeInputs[element.name] = element.value;
        });
        codeInputs['_token'] = document.head.querySelector('meta[name="csrf-token"]');

        axios.post(actionLink, {...codeInputs})
            .then(function (response) {
                $('.modal-js-phone-ver-container').hide().html(response.data.form).fadeIn();
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 422) {
                        $(inputGroupRef).siblings('.invalid-feedback').html(error.response.data.message);
                        $(inputGroupRef).parent().addClass('is-invalid');
                    }
                }
            });
    });


    $(document).on('click', '.js-code-resend', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const actionLink = e.target.href;
        const inputGroupRef = document.getElementsByClassName('sms-code-check-group')[0];

        $(inputGroupRef).siblings('.invalid-feedback').html('');
        $(inputGroupRef).parent().removeClass('is-invalid');

        axios.post(actionLink, {})
            .then(function (response) {
                //
            })
            .catch(function (error) {
                if (error.response) {
                    if (error.response.status === 422) {
                        $(inputGroupRef).siblings('.invalid-feedback').html(error.response.data.message);
                        $(inputGroupRef).parent().addClass('is-invalid');

                        if (error.response.data.type === 'limit_reached') {
                            $('.resend-container').css('opacity', 0);
                            $('.resend-container a').css('display', 'none');
                        }
                    }
                }
            });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/phoneValidate.js